import ArrowRight from '@/assets/images/tmds/ico_arrow_right.svg?react'
import ArrowUp from '@/assets/images/tmds/ico_arrow_up.svg?react'
import ArrowUpBold from '@/assets/images/tmds/ico_arrow_up_bold.svg?react'
import ArrowDown from '@/assets/images/tmds/ico_arrow_down.svg?react'
import ArrowDownBold from '@/assets/images/tmds/ico_arrow_down_bold.svg?react'
import ArrowTaleRight from '@/assets/images/tmds/ic_arrow_tale_right.svg?react'
import ArrowRightBold from '@/assets/images/tmds/arrow_right_bold.svg?react'
import ArrowLeft from '@/assets/images/tmds/ico_arrow_left.svg?react'
import Exit from '@/assets/images/tmds/ico_exit.svg?react'
import Share from '@/assets/images/tmds/ico_share.svg?react'
import LineBetween from '@/assets/images/tmds/ic_line_between.svg?react'
import Phone from '@/assets/images/tmds/ico_phone.svg?react'
import Question from '@/assets/images/tmds/ico_question.svg?react'
import Plus from '@/assets/images/tmds/ico_plus.svg?react'
import Refresh from '@/assets/images/tmds/ic_refresh.svg?react'
import PencilSolid from '@/assets/images/tmds/ico_pencil_solid.svg?react'
import Pencil from '@/assets/images/tmds/ico_pencil.svg?react'
import Info from '@/assets/images/tmds/ico_information.svg?react'
import Clipboard from '@/assets/images/tmds/ic_clipboard.svg?react'
import Trash from '@/assets/images/tmds/ic_trash.svg?react'
import Duplicate from '@/assets/images/tmds/ic_duplicate.svg?react'
import ExitCircle from '@/assets/images/tmds/ico_exit_circle.svg?react'
import InfoSolid from '@/assets/images/tmds/ico_information_solid.svg?react'
import DotBullet from '@/assets/images/tmds/ic_dot_bullet.svg?react'
import DotBetween from '@/assets/images/tmds/ico_dot_between.svg?react'
import Star from '@/assets/images/tmds/ic_star_fill.svg?react'
import MapRoute from '@/assets/images/tmds/map_route.svg?react'
import PenEdit from '@/assets/images/tmds/ic_pen_edit.svg?react'
import Talk from '@/assets/images/tmds/ic_talk.svg?react'
import Like from '@/assets/images/tmds/ic_like.svg?react'

export const Icons = {
  ArrowRight,
  ArrowUp,
  ArrowUpBold,
  ArrowDown,
  ArrowDownBold,
  ArrowTaleRight,
  ArrowRightBold,
  ArrowLeft,
  Exit,
  Share,
  LineBetween,
  Phone,
  Question,
  Plus,
  Refresh,
  PencilSolid,
  Pencil,
  Info,
  Clipboard,
  Trash,
  Duplicate,
  ExitCircle,
  InfoSolid,
  DotBullet,
  DotBetween,
  Star,
  MapRoute,
  PenEdit,
  Talk,
  Like,
}
